(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const cartForm = document.querySelector('.lunaria-cart__layout');

  if (cartForm) {
    cartForm.addEventListener('change', (event) => {
      if (event.target.matches('.lunaria-cart__qty-input')) {
        cartForm.submit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const initHeaderDropdowns = (root = document) => {
    root.querySelectorAll('.header__menu-item--dropdown').forEach((item) => {
      if (item.dataset.dropdownInit === 'true') {
        return;
      }

      item.dataset.dropdownInit = 'true';

      const trigger = item.querySelector('.header__menu-trigger');
      const mobileQuery = window.matchMedia('(max-width: 1280px)');

      const setExpanded = (isOpen) => {
        item.classList.toggle('is-open', isOpen);
        trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      };

      trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const shouldOpen = !item.classList.contains('is-open');

        root.querySelectorAll('.header__menu-item--dropdown.is-open').forEach((openItem) => {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.header__menu-trigger')?.setAttribute('aria-expanded', 'false');
          }
        });

        setExpanded(shouldOpen);
      });

      document.addEventListener('click', (event) => {
        if (!item.contains(event.target)) {
          setExpanded(false);
        }
      });

      item.addEventListener('focusout', (event) => {
        if (mobileQuery.matches || item.contains(event.relatedTarget)) {
          return;
        }

        setExpanded(false);
      });
    });
  };

  initHeaderDropdowns();

  document.addEventListener('shopify:section:load', (event) => {
    initHeaderDropdowns(event.target);
  });

  const initMobileHeaderMenu = (root = document) => {
    root.querySelectorAll('.site-header').forEach((header) => {
      if (header.dataset.mobileMenuInit === 'true') {
        return;
      }

      header.dataset.mobileMenuInit = 'true';

      const toggle = header.querySelector('[data-header-menu-toggle]');
      const menu = header.querySelector('[data-header-menu]');
      const mobileQuery = window.matchMedia('(max-width: 1280px)');

      if (!toggle || !menu) {
        return;
      }

      const setMenuOpen = (isOpen) => {
        header.classList.toggle('is-menu-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      };

      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        setMenuOpen(!header.classList.contains('is-menu-open'));
      });

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          if (mobileQuery.matches) {
            setMenuOpen(false);
          }
        });
      });

      document.addEventListener('click', (event) => {
        if (!mobileQuery.matches || !header.classList.contains('is-menu-open')) {
          return;
        }

        if (!header.contains(event.target)) {
          setMenuOpen(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('is-menu-open')) {
          setMenuOpen(false);
          toggle.focus();
        }
      });

      mobileQuery.addEventListener('change', () => {
        setMenuOpen(false);
      });
    });
  };

  initMobileHeaderMenu();

  document.addEventListener('shopify:section:load', (event) => {
    initMobileHeaderMenu(event.target);
  });

  const initHeaderSearchPopover = (root = document) => {
    root.querySelectorAll('[data-header-search-popover]').forEach((popover) => {
      if (popover.dataset.searchPopoverInit === 'true') {
        return;
      }

      popover.dataset.searchPopoverInit = 'true';

      const sectionRoot = popover.closest('.shopify-section') || root;
      const openButtons = sectionRoot.querySelectorAll('[data-header-search-open]');
      const closeButtons = popover.querySelectorAll('[data-header-search-close]');
      const form = popover.querySelector('form');
      const input = popover.querySelector('[data-header-search-input]');
      const results = popover.querySelector('[data-header-search-results]');
      const suggestUrl = popover.dataset.searchSuggestUrl;
      const emptyText = results?.dataset.emptyText || 'No results found for [query]';
      const loadingText = results?.dataset.loadingText || 'Searching...';
      const minText = results?.dataset.minText || 'Type at least 3 characters.';
      const viewAllText = results?.dataset.viewAllText || 'View all results';
      let debounceTimer;
      let activeRequest;

      const setStatus = (message) => {
        if (!results) {
          return;
        }

        results.replaceChildren();

        const status = document.createElement('p');
        status.className = 'header-search-popover__status';
        status.textContent = message;
        results.append(status);
      };

      const getProductPrice = (product) => {
        if (typeof product.price === 'string') {
          return product.price;
        }

        if (typeof product.price_min === 'string') {
          return product.price_min;
        }

        if (typeof product.price === 'number' && window.Shopify?.formatMoney) {
          return window.Shopify.formatMoney(product.price);
        }

        return '';
      };

      const getProductImage = (product) => {
        if (typeof product.image === 'string') {
          return product.image;
        }

        if (typeof product.image?.url === 'string') {
          return product.image.url;
        }

        return '';
      };

      const getSearchUrl = (query) => {
        const searchUrl = new URL(form.action, window.location.origin);
        searchUrl.searchParams.set('type', 'product');
        searchUrl.searchParams.set('q', query);
        return searchUrl;
      };

      const searchPageHasResults = async (query, signal) => {
        try {
          const response = await fetch(getSearchUrl(query).toString(), {
            signal,
            headers: {
              Accept: 'text/html',
            },
          });

          if (!response.ok) {
            return false;
          }

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return Boolean(doc.querySelector('.search-results .lunaria-content-card'));
        } catch (error) {
          if (error.name === 'AbortError') {
            throw error;
          }

          return false;
        }
      };

      const renderResults = async (products, query, signal) => {
        if (!results) {
          return;
        }

        results.replaceChildren();

        if (products.length === 0) {
          setStatus(emptyText.replace('[query]', query));
          return;
        }

        products.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'header-search-popover__result';
          link.href = product.url;
          const imageUrl = getProductImage(product);

          if (imageUrl) {
            const image = document.createElement('img');
            image.className = 'header-search-popover__result-image';
            image.src = imageUrl;
            image.alt = product.title || '';
            image.loading = 'lazy';
            link.append(image);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'header-search-popover__result-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            placeholder.textContent = ' ';
            link.append(placeholder);
          }

          const content = document.createElement('span');
          const title = document.createElement('strong');
          title.className = 'header-search-popover__result-title';
          title.textContent = product.title || '';
          content.append(title);

          const price = getProductPrice(product);
          if (price) {
            const priceElement = document.createElement('span');
            priceElement.className = 'header-search-popover__result-price';
            priceElement.textContent = price;
            content.append(priceElement);
          }

          link.append(content);
          results.append(link);
        });

        if (await searchPageHasResults(query, signal)) {
          const viewAll = document.createElement('a');
          viewAll.className = 'header-search-popover__view-all';
          viewAll.href = getSearchUrl(query).toString();
          viewAll.textContent = viewAllText;
          results.append(viewAll);
        }
      };

      const searchProducts = async (query) => {
        activeRequest?.abort();
        const request = new AbortController();
        activeRequest = request;
        setStatus(loadingText);

        const requestUrl = new URL(suggestUrl, window.location.origin);
        requestUrl.searchParams.set('q', query);
        requestUrl.searchParams.set('resources[type]', 'product');
        requestUrl.searchParams.set('resources[limit]', '10');
        requestUrl.searchParams.set('resources[options][unavailable_products]', 'hide');

        try {
          const response = await fetch(requestUrl.toString(), {
            signal: request.signal,
            headers: {
              Accept: 'application/json',
            },
          });

          if (!response.ok) {
            throw new Error(`Predictive search failed with ${response.status}`);
          }

          const data = await response.json();
          await renderResults(data?.resources?.results?.products || [], query, request.signal);
        } catch (error) {
          if (error.name !== 'AbortError') {
            setStatus(emptyText.replace('[query]', query));
          }
        }
      };

      const scheduleSearch = () => {
        const query = input.value.trim();
        window.clearTimeout(debounceTimer);
        activeRequest?.abort();

        if (query.length < 3) {
          setStatus(minText);
          return;
        }

        debounceTimer = window.setTimeout(() => searchProducts(query), 220);
      };

      const openPopover = () => {
        popover.hidden = false;
        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
        });
        window.setTimeout(() => input?.focus(), 0);
        scheduleSearch();
      };

      const closePopover = () => {
        popover.hidden = true;
        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();

          if (popover.hidden) {
            openPopover();
          } else {
            closePopover();
          }
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closePopover);
      });

      input?.addEventListener('input', scheduleSearch);
      form?.addEventListener('submit', (event) => {
        event.preventDefault();
      });

      popover.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      document.addEventListener('click', (event) => {
        if (popover.hidden || popover.contains(event.target)) {
          return;
        }

        const clickedTrigger = [...openButtons].some((button) => button.contains(event.target));
        if (!clickedTrigger) {
          closePopover();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popover.hidden) {
          closePopover();
        }
      });
    });
  };

  initHeaderSearchPopover();

  document.addEventListener('shopify:section:load', (event) => {
    initHeaderSearchPopover(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunaria-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('ContactForm');
    const submit = form?.querySelector('[data-contact-submit]');

    if (!form || !submit) return;

    const enableSubmit = () => {
      submit.disabled = false;
      submit.removeAttribute('aria-disabled');
    };

    if (window.Shopify?.captcha?.protect) {
      window.Shopify.captcha.protect(form, enableSubmit);
      return;
    }

    enableSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunaria-gallery"] && !Shopify.designMode) return;
  try {
    
  const initGalleryLightbox = (gallery) => {
    if (gallery.dataset.lightboxInit === 'true') {
      return;
    }

    gallery.dataset.lightboxInit = 'true';

    const dialog = gallery.querySelector('.lunaria-gallery-lightbox');
    const image = gallery.querySelector('.lunaria-gallery-lightbox__image');
    const closeButton = gallery.querySelector('[data-lightbox-close]');
    const prevButton = gallery.querySelector('[data-lightbox-prev]');
    const nextButton = gallery.querySelector('[data-lightbox-next]');

    if (!dialog || !image) {
      return;
    }

    let currentIndex = 0;

    const getTriggers = () => [...gallery.querySelectorAll('.lunaria-gallery__trigger')];

    const showImage = (index) => {
      const triggers = getTriggers();
      const trigger = triggers[index];

      if (!trigger) {
        return;
      }

      currentIndex = index;
      image.src = trigger.dataset.lightboxSrc;
      image.alt = trigger.dataset.lightboxAlt || '';

      if (prevButton && nextButton) {
        const hasMultiple = triggers.length > 1;
        prevButton.hidden = !hasMultiple;
        nextButton.hidden = !hasMultiple;
      }
    };

    const openLightbox = (index) => {
      showImage(index);
      if (!dialog.open) {
        dialog.showModal();
      }
    };

    const closeLightbox = () => {
      if (dialog.open) {
        dialog.close();
      }
      image.removeAttribute('src');
    };

    gallery.addEventListener('click', (event) => {
      const trigger = event.target.closest('.lunaria-gallery__trigger');

      if (!trigger || !gallery.contains(trigger)) {
        return;
      }

      const triggers = getTriggers();
      const index = triggers.indexOf(trigger);

      if (index >= 0) {
        openLightbox(index);
      }
    });

    closeButton?.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeLightbox();
      }
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeLightbox();
    });

    prevButton?.addEventListener('click', () => {
      const triggers = getTriggers();
      showImage((currentIndex - 1 + triggers.length) % triggers.length);
    });

    nextButton?.addEventListener('click', () => {
      const triggers = getTriggers();
      showImage((currentIndex + 1) % triggers.length);
    });

    dialog.addEventListener('keydown', (event) => {
      const triggers = getTriggers();

      if (triggers.length <= 1) {
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage((currentIndex - 1 + triggers.length) % triggers.length);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage((currentIndex + 1) % triggers.length);
      }
    });
  };

  document.querySelectorAll('.lunaria-gallery').forEach(initGalleryLightbox);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.lunaria-gallery').forEach(initGalleryLightbox);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunaria-inquiry-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('InquiryForm');
    const submit = form?.querySelector('[data-inquiry-submit]');

    if (!form || !submit) return;

    const enableSubmit = () => {
      submit.disabled = false;
      submit.removeAttribute('aria-disabled');
    };

    if (window.Shopify?.captcha?.protect) {
      window.Shopify.captcha.protect(form, enableSubmit);
      return;
    }

    enableSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const initProductGallery = (section) => {
    const gallery = section.querySelector('[data-product-gallery]');
    if (!gallery) {
      return;
    }

    const mainImage =
      gallery.querySelector('[data-product-gallery-main]') ||
      gallery.querySelector('.lunaria-product-gallery__main img');
    if (!mainImage) {
      return;
    }

    const thumbs = [...gallery.querySelectorAll('.lunaria-product-gallery__thumb')];
    const form = section.querySelector('.lunaria-product-form');
    const variantSelect = form?.querySelector('[data-product-variant-select]');
    const priceEl = section.querySelector('[data-product-price]');
    const submitButton = form?.querySelector('[data-product-submit]');

    const setActiveMedia = (mediaId) => {
      const thumb = thumbs.find((item) => item.dataset.mediaId == mediaId);
      if (!thumb) {
        return;
      }

      if (thumb.dataset.srcset) {
        mainImage.srcset = thumb.dataset.srcset;
      } else {
        mainImage.removeAttribute('srcset');
      }

      mainImage.src = thumb.dataset.src;

      if (thumb.dataset.alt) {
        mainImage.alt = thumb.dataset.alt;
      }

      thumbs.forEach((item) => {
        const isActive = item.dataset.mediaId == mediaId;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const updateVariantFields = () => {
      if (!variantSelect) {
        return;
      }

      const selectedOption = variantSelect.selectedOptions[0];
      if (!selectedOption) {
        return;
      }

      if (priceEl && selectedOption.dataset.price) {
        priceEl.textContent = selectedOption.dataset.price;
      }

      if (submitButton) {
        const isAvailable = !selectedOption.disabled;
        submitButton.disabled = !isAvailable;
        submitButton.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }
    };

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('.lunaria-product-gallery__thumb');
      if (!thumb || !gallery.contains(thumb)) {
        return;
      }

      setActiveMedia(thumb.dataset.mediaId);

      if (variantSelect && thumb.dataset.variantId) {
        variantSelect.value = thumb.dataset.variantId;
        updateVariantFields();
      }
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        updateVariantFields();

        const selectedOption = variantSelect.selectedOptions[0];
        if (selectedOption?.dataset.mediaId) {
          setActiveMedia(selectedOption.dataset.mediaId);
        }
      });
    }
  };

  document.querySelectorAll('.lunaria-product-page').forEach(initProductGallery);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.lunaria-product-page').forEach(initProductGallery);
  });

  } catch(e) { console.error(e); }
})();
})();
